import {
  Component,
  inject,
  OnInit,
  signal,
  computed,
  EventEmitter,
  Output,
  Input,
  ViewChild,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ClientService } from '../../services/client.service';
import { Client, Clients } from '../../interfaces/client';

@Component({
  selector: 'app-client-selector',
  standalone: true,
  imports: [DropdownModule, ReactiveFormsModule],
  templateUrl: './client-selector.component.html',
})
export class ClientSelectorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() dialogVisible = false;
  @Output() clientSelected = new EventEmitter<Client>();
  @ViewChild(Dropdown) dropdown!: Dropdown;

  private _clientService = inject(ClientService);
  private clientsLoaded = false;
  clients = signal<Clients>({} as Clients);
  clientOptions = computed(() => {
    const data = this.clients().data;
    if (Array.isArray(data)) {
      return data.map((client) => ({
        label: client.attributes.name,
        value: client,
      }));
    } else {
      return [];
    }
  });

  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;

  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => this._clientService.searchClients(query))
    ).subscribe({
      next: (clients) => {
        this.clients.set(clients);
        this.clientsLoaded = true;
      },
      error: () => console.error('Error al buscar clientes')
    });

    if (this.dialogVisible) {
      this.loadClientsIfNeeded();
    }
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  ngOnChanges(): void {
    if (this.dropdown) {
      this.dropdown.clear();
    }
    if (this.dialogVisible && !this.clientsLoaded) {
      this.loadClientsIfNeeded();
    }
  }

  private loadClientsIfNeeded(): void {
    if (!this.clientsLoaded) {
      this.searchSubject.next('');
    }
  }

  onFilterClients(event: any): void {
    this.searchSubject.next(event.filter);
  }

  onClientChange(event: any): void {
    this.clientSelected.emit(event.value);
  }
}
